if (!customElements.get('cart-tier-bar')) {
  class CartTierBar extends HTMLElement {
    connectedCallback() {
      this.fillEl = this.querySelector('[data-tier-fill]');
      this.labelEl = this.querySelector('[data-tier-label]');
      this.tier2 = parseInt(this.dataset.tier2Qty, 10) || 2;
      this.tier3 = parseInt(this.dataset.tier3Qty, 10) || 3;
      this.giftVariantId = parseInt(this.dataset.giftVariantId, 10) || null;

      // Liquid ne pehle hi correct state render kar diya hai — ab sirf
      // future cart changes pe react karna hai, extra fetch nahi chahiye.
      this._onCartUpdated = (event) => {
        if (event.detail) this.render(this._nonGiftCount(event.detail));
      };
      document.addEventListener('cart:updated', this._onCartUpdated);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this._onCartUpdated);
    }

    _nonGiftCount(cart) {
      if (!this.giftVariantId) return cart.item_count;
      return cart.items.reduce((sum, item) => (
        item.variant_id === this.giftVariantId ? sum : sum + item.quantity
      ), 0);
    }

    render(count) {
      let pct, label;
      if (count >= this.tier3) {
        pct = 100;
        label = "You've unlocked 15% off + a free Perfume Box! 🎉";
      } else if (count >= this.tier2) {
        const remaining = this.tier3 - count;
        pct = 50 + ((count - this.tier2) / (this.tier3 - this.tier2)) * 50;
        label = `Add ${remaining} more to unlock 15% off + a free gift!`;
      } else {
        const remaining = this.tier2 - count;
        pct = (count / this.tier2) * 50;
        label = remaining > 0 ? `Add ${remaining} more to unlock 10% off!` : 'Add 1 more to unlock 10% off!';
      }
      this.fillEl.style.width = `${Math.min(pct, 100)}%`;
      this.labelEl.textContent = label;
      this.classList.toggle('cart-tier-bar--tier2', count >= this.tier2 && count < this.tier3);
      this.classList.toggle('cart-tier-bar--tier3', count >= this.tier3);
    }
  }
  customElements.define('cart-tier-bar', CartTierBar);
}

if (!customElements.get('cart-upsell')) {
  class CartUpsell extends HTMLElement {
    connectedCallback() {
      this.listEl = this.querySelector('[data-upsell-list]');
      this.limit = parseInt(this.dataset.limit, 10) || 4;

      const poolEl = this.querySelector('[data-upsell-pool]');
      try {
        this.pool = JSON.parse(poolEl.textContent).filter((p) => p.available !== false);
      } catch (err) {
        this.pool = [];
      }

      this._onCartUpdated = (event) => {
        if (event.detail) this.render(event.detail);
      };
      document.addEventListener('cart:updated', this._onCartUpdated);

      fetch('/cart.js', { cache: 'no-store' })
        .then((r) => r.json())
        .then((cart) => this.render(cart))
        .catch(() => {});
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this._onCartUpdated);
    }

    render(cart) {
      const cartProductIds = new Set(cart.items.map((i) => i.product_id));
      const filtered = this.pool.filter((p) => !cartProductIds.has(p.id)).slice(0, this.limit);

      if (!filtered.length) { this.hidden = true; return; }
      this.hidden = false;
      this.listEl.innerHTML = filtered.map((p) => this.card(p)).join('');
      this.listEl.querySelectorAll('[data-add-btn]').forEach((btn) => {
        btn.addEventListener('click', (e) => this.addToCart(e));
      });
    }

    card(product) {
      const price = (product.price / 100).toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
      return `
        <div class="cart-upsell__item">
          <img src="${product.image}" width="48" height="48" alt="${product.title}" loading="lazy">
          <div class="cart-upsell__info">
            <p class="cart-upsell__title">${product.title}</p>
            <p class="cart-upsell__price">${price}</p>
          </div>
          <button class="cart-upsell__add" data-add-btn data-variant-id="${product.variant_id}">+ Add</button>
        </div>`;
    }

    async addToCart(e) {
      const btn = e.currentTarget;
      btn.disabled = true;
      btn.textContent = '...';
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: btn.dataset.variantId, quantity: 1 }] }),
        });
        // fetch-patch neeche cart:updated dispatch kar dega — usse
        // cart-items-component bhi list + free-gift check refresh kar lega.
      } catch (err) {
        btn.disabled = false;
        btn.textContent = '+ Add';
      }
    }
  }
  customElements.define('cart-upsell', CartUpsell);
}

// Ab mutation response ka cart data seedha event.detail me jaata hai —
// isliye koi extra /cart.js fetch nahi, koi race condition nahi.
// Respects window.__mgcSuppressCartEvent so our own internal gift
// add/remove calls (from cart-items.js) don't re-trigger this loop.
(() => {
  if (window.__mgcCartPatchApplied) return;
  window.__mgcCartPatchApplied = true;

  const originalFetch = window.fetch;
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    const isCartMutation = url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update');

    if (isCartMutation && !window.__mgcSuppressCartEvent) {
      response.clone().json()
        .then((cart) => document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart })))
        .catch(() => {});
    }
    return response;
  };
})();

